/*
 * lunna-gallery-zoom.js — the pointer decides what gets bigger.
 *
 * Only writes `transform-origin`. The scale, the timing and the cursor all
 * live in lunna-gallery-zoom.css, so what happens on hover stays a styling
 * decision and this file stays a question of where the pointer is.
 *
 * Deliberately bound to a mouse. A fine pointer hovering is an unambiguous
 * request to look closer; a finger touching the same box is trying to scroll
 * the page or open the lightbox, and hijacking that would break both. Touch
 * visitors keep the lightbox, which is the better tool there anyway — it
 * pinches. `pointerenter` is checked for `pointerType` rather than trusting
 * the media query alone, because a hybrid laptop matches `hover: hover` and
 * still gets touched.
 *
 * Video and 3D media are skipped: their frames own their own interactions and
 * a scaled `<video>` inside a clipped box would hide its controls.
 */
(function () {
  'use strict';

  if (window.LunnaGalleryZoom) return;
  window.LunnaGalleryZoom = true;

  var fine = window.matchMedia('(hover: hover) and (pointer: fine)');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function eligible(box) {
    if (box.querySelector('.deferred-media, product-model, video, model-viewer')) return false;
    return !!box.querySelector('img');
  }

  function bind(box) {
    if (box.dataset.lunnaZoom || !eligible(box)) return;

    var img = box.querySelector('img');
    box.dataset.lunnaZoom = '1';

    function origin(event) {
      var rect = box.getBoundingClientRect();
      if (!rect.width || !rect.height) return;

      var x = ((event.clientX - rect.left) / rect.width) * 100;
      var y = ((event.clientY - rect.top) / rect.height) * 100;

      // Clamped so a pointer at the very edge cannot pull the origin outside
      // the frame, which would swing the image away instead of toward it.
      img.style.transformOrigin =
        Math.max(0, Math.min(100, x)) + '% ' + Math.max(0, Math.min(100, y)) + '%';
    }

    box.addEventListener('pointerenter', function (event) {
      if (event.pointerType !== 'mouse') return;
      if (!fine.matches || reduce.matches) return;

      origin(event);
      box.classList.add('lunna-zoom--on');
    });

    box.addEventListener('pointermove', function (event) {
      if (!box.classList.contains('lunna-zoom--on')) return;
      origin(event);
    });

    function release() {
      box.classList.remove('lunna-zoom--on');
      img.style.removeProperty('transform-origin');
    }

    box.addEventListener('pointerleave', release);
    // A touch anywhere on the box cancels a zoom a mouse may have left behind
    // on a hybrid machine, so the lightbox never opens over a scaled image.
    box.addEventListener('pointerdown', function (event) {
      if (event.pointerType !== 'mouse') release();
    });
  }

  /* The main gallery only. The lightbox has its own zoom, and the thumbnails
     are targets to press rather than things to inspect. */
  function scan(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('media-gallery [id^="GalleryViewer"] .product__media').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scan();
    });
  } else {
    scan();
  }

  // Variant changes re-render the media, and the theme editor re-renders the
  // whole section. Either way the new boxes arrive unbound.
  document.addEventListener('shopify:section:load', function (event) {
    scan(event.target);
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS === 'object' && PUB_SUB_EVENTS) {
    subscribe(PUB_SUB_EVENTS.variantChange, function () {
      window.requestAnimationFrame(function () {
        scan();
      });
    });
  }
})();
